import getConfig from 'next/config'

/**
 * Debug helper
 * @description Debug by logging msg to the console in non-production environments
 * Don't use it to replace console.log
 * @example
 * logDebug('This is a log message')
 */

export const logDebug = (...args: any[]) => {
  if (getConfig().publicRuntimeConfig.env !== 'prd') {
    console.log(...args)
  }
}
